import { render } from "./card-item-menu.vue?vue&type=template&id=80f456ca"
import script from "./card-item-menu.js?vue&type=script&lang=js&external"
export * from "./card-item-menu.js?vue&type=script&lang=js&external"

import "./card-item-menu.vue?vue&type=style&index=0&id=80f456ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__